import { Accordion, AccordionHeader, AccordionItem, AccordionPanel, Body1Stronger, TableCell, TableHeaderCell, TableRow, mergeClasses } from "@fluentui/react-components";
import { addDays, isSameDay } from "date-fns";
import { useGlobalStatus } from "../../services/GlobalStatusProvider";
import TooltipWatcherWidget from '../TooltipWatcherWidget';


export default function HolidayRow({ calendarData }) {


  const { currentWeekStart, useStyles, isDesktop } = useGlobalStatus();

  const calendarNameMap = {
    "Australia": "Australia",
    "Australia - New South Wales": "NSW",
    "Australia - Victoria": "VIC",
    "Australia - Queensland": "QLD",
    "Australia - South Australia": "SA",
    "Australia - Western Australia": "WA",
    "Australia - Tasmania": "TAS",
    "Australia - Northern Territory": "NT",
    "Australia - Australian Capital Territory": "ACT",
  };

  const styles = useStyles();
  const dates = Array.from({ length: 7 }, (_, i) => addDays(currentWeekStart, i));
  if (!calendarData) {
    return null;
  }
  // 
  // Convert into a "project with timecodes" structure

  const holidayCalendars = {
    projectName: "HolidayCalendars",

    timecodes: calendarData.filter((calendar) => calendar.holidays && calendar.holidays.length > 0)
      // 2. Then map the valid ones
      .map((calendar) => {

        return {
          calendarId: calendar.holidayCalendarID,
          calendarName: calendar.calendarName,

          entries: calendar.holidays.map(h => ({
            holidayID: h.holidayID,
            holidayName: h.holidayName,
            date: h.observedDate,
          }))
        };
      })
  };

  // Desktop Table
  if (isDesktop) {
    return holidayCalendars.timecodes.map((tc, index) => (
      <TableRow key={`holiday-calendar-${tc.calendarName}`}>
        {index === 0 && (
          <TableHeaderCell rowSpan={holidayCalendars.timecodes.length} style={{ fontWeight: "bold" }}>
            <TooltipWatcherWidget text="Holidays for the week" direction="below-start">
              <span>Holidays</span>
            </TooltipWatcherWidget>
          </TableHeaderCell>
        )}
        <TableCell style={{ backgroundColor: "#eff1f5" }}>{calendarNameMap[tc.calendarName] ?? tc.calendarName}</TableCell>
        {dates.map((date, i) => {
          const holiday = tc.entries.find((entry) =>
            isSameDay(entry.date, date)
          );

          return (
            <TableCell
              key={`holiday-cell-${i}`}
              style={{ backgroundColor: holiday ? "#8cbeb3" : "#F3F3F3" }}
            >
              <div className="table-total-cell">
                {holiday ? (
                  <Body1Stronger>{holiday.holidayName}</Body1Stronger>
                ) : (
                  <span></span>
                )}
              </div>
            </TableCell>
          );
        })}
        <TableCell style={{ backgroundColor: "#F3F3F3" }} />
      </TableRow>
    ));
  }
  else {
    return (
      <Accordion collapsible>
        {holidayCalendars.timecodes.map((tc, index) => (
          <AccordionItem key={`holiday-${tc.calendarName}`} value={`holiday-${index}`}>
            <AccordionHeader className={mergeClasses(styles.accordionHeader)}>{` ${tc.calendarName}`}</AccordionHeader>
            <AccordionPanel>
              {dates.map((date, i) => {
                const holiday = tc.entries.find((entry) =>
                  isSameDay(entry.date, date)
                );

                return (
                  holiday && (
                    <div
                      key={i}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "8px",
                        marginBottom: "4px",
                        borderRadius: "4px",
                        backgroundColor: "#8cbeb3"
                      }}
                    >
                      <span>{date.toDateString() ?? "No Date Found"}</span>
                      <br />
                      <Body1Stronger>{holiday.holidayName}</Body1Stronger>
                    </div>
                  )
                );
              })}
            </AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>
    );
  }
}